const Crypto = require('crypto-js');
const requestHelper = require('./requestHelper');

const common = {
    createMessage: (moduleName) => `${moduleName} created succesfully.`,
    updateMessage: (moduleName) => `${moduleName} updated succesfully.`,
    deleteMessage: (moduleName) => `${moduleName} deleted succesfully.`,
    copyMessage: (moduleName) => `${moduleName} copied succesfully.`,
    commonMessage: (moduleName) => `${moduleName}`,
    objectToBase64: (object) => {
        return btoa(JSON.stringify(object));
    },
    base64ToObject: (object) => {
        return JSON.parse(atob(object));
    },
    isEmpty: (value) => {
        return value == null || value === '' || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    generateToken: () =>{
        const timestamp = new Date().getTime().toString();
        const randomString = Math.random().toString(36).substring(2);
        const token = timestamp + randomString;
        const hashedToken = Crypto.SHA256(token).toString();
        return hashedToken;
    },
    generateSecretKey: () => {
        const length = 6
        const characters = 'ABCDEFGHIJ0123456789KLMNOPQRSTUVWXYZ'
        return Array.from({ length }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
    },
    countries: async() => {
        const countyData = await requestHelper.request('/countries', null, 'get');
        let result = countyData?.data || [];
        if (result.statusCode === 200) {
            result = result.data;
        }
        return result;
    },
    currencies: async () => {
        const currencyData = await requestHelper.request('/currencyCode', null, 'get');
        let result = currencyData?.data || [];
        if (result.statusCode === 200) {
            result = result.data;

        }
        return result;
    },
    selectMerchants: async () => { 
        const getMerchantList = await requestHelper.request('/getUserMerchantDetails', null, 'get');
        let merchantSelect =  getMerchantList?.data || [];
        console.log(merchantSelect);
        if (merchantSelect?.statusCode === 200) {
            merchantSelect = merchantSelect?.data.map(value => ({
                value: value.merchantId,
                text: value.merchantName
            }));
        }
        return merchantSelect;
    },
    getPgs: async () => {
        let pgList = [];
        const getPgsList = await requestHelper.request('/getPGs', null, 'get');
        let result = getPgsList.data;
        
        if (result.statusCode === 200) {
            pgList = result.data.map(pg => ({
                text: pg.pgName,
                value: pg.pgId
            })); 
        }
        return pgList;
    },
    async getMerchantPos(merchantId) {
        let posList = [];
        const getMerchantPosList = await requestHelper.request(`/getPosIdList/${merchantId}`, null, 'get');
        const result =  getMerchantPosList.data;
        if (result.statusCode == '200') {
            posList = result.data.map(pos => ({
                text: pos.name,
                value: pos.id
            }));
        }
        return posList;
    },
    async userRoles() {
        let rolesList = [];
        const rolesData = await requestHelper.request(`/getMechantRoles`,null , 'get');
        if (rolesData.data.statusCode === 200) {
            roles = await rolesData.data.data;
            
            rolesList = await roles.map(value => {
                return {
                    value: value.roleId,
                    text: value.roleName
                }
            });
        }
        return rolesList;
    },
    async apiKey() {
        let apiKey = ''
        const result = await requestHelper.request(`/getApiKey`,null , 'get');
        if (result?.data?.statusCode === 200) {
            const data = result.data.data;
            apiKey = data.apiKey;
            
        }
        return apiKey;
    },
    async secretKey() {
        let secretKey = '';
        const result = await requestHelper.request(`/getSecretKey`,null , 'get');
        if (result?.data?.statusCode === 200) {
            const data = result?.data?.data;
            secretKey = data.secretKey;
        }
        return secretKey;
    },
    generateRandomChars (length) {
        const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        return Array.from({ length }, () => characters[Math.floor(Math.random() * characters.length)])
            .join('')
            .toUpperCase();
    },
    arrayToBase64(redirectData) {
        const jsonString = JSON.stringify(redirectData);
        const base64Encoded = btoa(jsonString);
        return base64Encoded;
    }
}

module.exports = common;